export default "__VITE_ASSET__TETsvvMN__"